export default __webpack_public_path__ + "static/media/puzzle-dark.838b8994.svg";